<script>
import { useIndexStore } from '@src/store'
import { login } from '@src/utils/auth'

export default {
  name: 'Login',
  data: () => {
    return {
      username: '',
      password: '',
      stayLogged: true,
      showPassword: true,
      logged: false,
    }
  },
  computed: {
    store () {
      return useIndexStore()
    },
    valid () {
      return this.username !== '' && this.password !== ''
    },
  },
  mounted () {
    this.store.changeRoute('login')
  },
  methods: {
    toggleShowPassword () {
      this.showPassword = !this.showPassword
    },
    signing () {
      login(this.username, this.password).then(() => {
        this.logged = true
        setTimeout(() => {
          this.$router.push('/')
        }, 1000)
      }).catch(() => {
        this.store.changeNotification({
          text: this.$gettext('Invalid username or password'),
          autoClose: true,
          type: 'error',
        })
      })
    },
  },
}
</script>
<template>
  <div class="layout">
    <div class="layout-overlay" />
    <v-card class="card login-card">
      <v-card-title class="title login-title">
        Traffic
      </v-card-title>
      <v-card-subtitle class="subtitle login-subtitle">
        {{ $gettext("Login") }}
      </v-card-subtitle>
      <v-card-text class="text login-text">
        <div>
          <!-- eslint-disable-next-line max-len -->
          {{ $gettext('You must be logged in to have access to this application. Please click on the button below to do so.') }}
        </div>
        <form>
          <v-text-field
            v-model="username"
            variant="underlined"
            :label="$gettext('Login')"
          />
          <v-text-field
            v-model="password"
            :type="showPassword ? 'password' : 'text'"
            variant="underlined"
            :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            :label="$gettext('Password')"
            @click:append="toggleShowPassword"
          />
        </form>
      </v-card-text>
      <div class="login-btn-container">
        <v-switch
          v-model="stayLogged"
          :label="$gettext('Stay logged in')"
          color="secondary"
          hide-details
        />
        <v-btn
          type="submit"
          color="primary"
          :disabled="!valid"
          :text="$gettext('Login')"
          @click="signing"
        />
      </div>
    </v-card>
  </div>
</template>
<style lang="scss" scoped>
.login-card {
  width: 500px;
  max-height: calc(100% - 2em);
  overflow-y: auto;
  padding: 40px;
}
.login-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
}
.login-subtitle {
  font-size: 2em;
  color: $secondary !important;
  text-align: center;
  font-weight: bold;
  padding: 30px;
}
.login-text {
  text-align: center;
}
.login-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.login-btn {
  margin-top: 20px;
  width: min-content;
}
</style>
